import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShowcaseService {
  public scrollObs$: BehaviorSubject<any> = new BehaviorSubject('');
  public categoryObs$: BehaviorSubject<any> = new BehaviorSubject('');

  constructor(private http: HttpClient) { }


  getShowcases(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/showcases`;
    return this.http.get(url);
  }

  getShowcaseList(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/showcaseMoviesList`
    return this.http.get(url);
  }

  getFeatureMovieList(): Observable<any> {
    const url = environment.apiURL + `/cinejoy/api/getMoviesList/category/nil/length/Features?parentcatname=Features`;
    return this.http.get(url);
  }
  getShortsMovieList(): Observable<any> {
    const url = environment.apiURL + `/cinejoy/api/getMoviesList/category/nil/length/Shorts?parentcatname=Shorts`;
    return this.http.get(url);
  }


  getMovieById(id): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/getMovieDetails/${id}`;
    return this.http.get(url);
  }
  addComment(id) {
    const url = environment.apiURL + `api/cinejoy/fetchAllCommentsWithReplyCounts/'${id}`;
    return this.http.get(url);
  }

  saveComment(data: any, id) {
    const url = environment.apiURL + `api/cinejoy/fetchAllCommentsWithReplyCounts/${id}`;
    return this.http.post(url, data).subscribe((result) => {
      console.log(result);
    });
  }

  getMoviesByCategories(data, category, subCat): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/getMoviesList/category/${subCat}/length/${category}?parentcatname=${data}`;
    return this.http.get(url)
  }

  getShowcaseArchiveListOnCategory(category, type, genre):Observable<any>{
    const url = environment.apiURL + `api/cinejoy/getArchivedMoviesList/category/${genre}/length/${type}?parentcatname=${category}`;
    return this.http.get(url)
  }

  getMovieStream(eventId): Observable<any> {
    const url = environment.apiURL + `api/v2/agiletix/customer/get/streaming/${eventId}`;
    return this.http.get(url);
  }

  postRating(movieId, rating):Observable<any>{
    let obj = {
      value: rating
    }

    const url = environment.apiURL+`api/cinejoy/rate/${movieId}?value=${rating}`;
    return this.http.post(url, null);
  }
}
